<template>
  <div>{{Espere}}</div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      Espere: "Espere un momento..."
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
     ...mapActions(["cargarData"]),
    ...mapActions("comun", ["quitarUsuario","LoguearCartilla","traerUserId"]),
    async fetchData() {
      await this.quitarUsuario();
      await this.LoguearCartilla();
      this.cargarData();
      this.traerUserId();
      this.$router.push("/cartillaOspetax");
    }
  }
};
</script>
